import React, { createContext, useRef } from "react";
import { Alerts } from "../components/home/Alerts";

export const AlertContext = createContext();

export const AlertProvider = ({ children }) => {

    const alertRef = useRef();

    return (
        <AlertContext.Provider value={{ alertRef }}>
            { children }
            <Alerts ref={ alertRef } />
        </AlertContext.Provider>
    )
};